import { ReactNode } from "react";
import { cn } from "../../utils/class-names";

interface ExternalLinkV2Props {
  className?: string;
  children?: ReactNode;
  href: string;
}

export function ExternalLinkV2({
  className,
  children,
  href,
}: ExternalLinkV2Props): JSX.Element {
  return (
    <a
      className={cn("flex items-center gap-1", className)}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
}
